var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9,
    height: 14,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3E0292",
    d: "M1.032 13.493a1 1 0 0 1-.725-.307A1 1 0 0 1 0 12.462V1.032Q0 .614.307.307A1 1 0 0 1 1.032 0h6.583q.419 0 .725.307a1 1 0 0 1 .307.725v11.43q0 .418-.307.724a1 1 0 0 1-.725.307zm0-2.394v1.363h6.583v-1.363zm3.294 1.135q.194 0 .323-.131a.45.45 0 0 0 .129-.326.447.447 0 0 0-.457-.452.447.447 0 0 0-.452.457q0 .195.132.324a.45.45 0 0 0 .325.128M1.032 10.19h6.583V2.395H1.032zm0-8.704h6.583v-.454H1.032z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e08a68281a35d78ef90241306ec31fc9.svg";
export { ForwardRef as ReactComponent };